@if (!isAddressMandatory()) {
  <div class="row">
    <div class="form-field-margin col-sm-12 cbw-invoice-address-toggle">
      <div class="custom-control d-flex custom-checkbox">
        <input
          id="external_invoice_different_address"
          class="custom-control-input cbw-custom-control-input"
          type="checkbox"
          role="checkbox"
          [checked]="checked()"
          (change)="onToggleChecked()"
          attr.aria-checked="{{ checked() }}"
        />
        <label id="label_external_invoice_different_address" for="external_invoice_different_address" class="custom-control-label d-flex w-100 ps-2">
          {{ 'summary_page_translations.external_invoice_different_address' | translate }}
        </label>
      </div>
    </div>
  </div>
}

@if (showForm()) {
  <div class="row">
    <div class="form-field-margin col-sm-12">
      <h4 class="cbw-invoice-address-title">{{ 'summary_page_translations.invoice_address_title' | translate }}</h4>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-firstname">
      <label class="input-label" for="invoice_address_prename" id="label_invoice_address_prename">
        {{ 'customer.prename.label' | translate }} *
      </label>
      <input
        id="invoice_address_prename"
        name="invoice_address_prename"
        type="text"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice given-name"
        [value]="prename()"
        (input)="prename.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('prename')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('prename') || isFieldPhishing('prename') }}"
        attr.aria-labelledby="label_invoice_address_prename"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('prename') || isFieldPhishing('prename') ? 'error_invoice_address_prename' : null"
      />
      @if (isFieldRequiredAndEmpty('prename')) {
        <div id="error_invoice_address_prename" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.prename.error.required' | translate }}
        </div>
      } @else if (isFieldPhishing('prename')) {
        <div id="error_invoice_address_prename" role="alert" class="alert alert-danger summary-warning">
          <span [innerHTML]="((widgetTemplates() | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang()) | trustHtml"></span>
        </div>
      }
    </div>

    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-lastname">
      <label class="input-label" for="invoice_address_lastname" id="label_invoice_address_lastname">
        {{ 'customer.lastname.label' | translate }} *
      </label>
      <input
        id="invoice_address_lastname"
        name="invoice_address_lastname"
        type="text"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice family-name"
        [value]="lastname()"
        (input)="lastname.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('lastname')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('lastname') || isFieldPhishing('lastname') }}"
        attr.aria-labelledby="label_invoice_address_lastname"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('lastname') || isFieldPhishing('lastname') ? 'error_invoice_address_lastname' : null"
      />
      @if (isFieldRequiredAndEmpty('lastname')) {
        <div id="error_invoice_address_lastname" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.lastname.error.required' | translate }}
        </div>
      } @else if (isFieldPhishing('lastname')) {
        <div id="error_invoice_address_lastname" role="alert" class="alert alert-danger summary-warning">
          <span [innerHTML]="((widgetTemplates() | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang()) | trustHtml"></span>
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 custom-field form-group summary-padding cbw-invoice-address-company">
      <label class="input-label" for="invoice_address_company_name" id="label_invoice_address_company_name">
        {{ 'common.company' | translate }}
      </label>
      <input
        id="invoice_address_company_name"
        name="invoice_address_company_name"
        type="text"
        class="form-control cbw-input-field"
        maxlength="255"
        autocomplete="section-invoice organization"
        [value]="companyName()"
        (input)="companyName.set($any($event.target).value); onFieldChange()"
        attr.aria-invalid="{{ isFieldPhishing('company_name') }}"
        attr.aria-labelledby="label_invoice_address_company_name"
        [attr.aria-describedby]="isFieldPhishing('company_name') ? 'error_invoice_address_company_name' : null"
      />
      @if (isFieldPhishing('company_name')) {
        <div id="error_invoice_address_company_name" role="alert" class="alert alert-danger summary-warning">
          <span [innerHTML]="((widgetTemplates() | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang()) | trustHtml"></span>
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-street">
      <label class="input-label" for="invoice_address_street" id="label_invoice_address_street">
        {{ 'customer.street.label' | translate }} *
      </label>
      <input
        id="invoice_address_street"
        name="invoice_address_street"
        type="text"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice street-address"
        [value]="street()"
        (input)="street.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('street')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('street') || isStreetTouchedAndMissingNumber() || isFieldPhishing('street') }}"
        attr.aria-labelledby="label_invoice_address_street"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('street') || isStreetTouchedAndMissingNumber() || isFieldPhishing('street') ? 'error_invoice_address_street' : null"
      />
      @if (isFieldRequiredAndEmpty('street')) {
        <div id="error_invoice_address_street" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.street.error.required' | translate }}
        </div>
      } @else if (isStreetTouchedAndMissingNumber()) {
        <div id="error_invoice_address_street" role="alert" class="alert alert-danger summary-warning">
          {{ 'summary_page_translations.invoice_address_street_error' | translate }}
        </div>
      } @else if (isFieldPhishing('street')) {
        <div id="error_invoice_address_street" role="alert" class="alert alert-danger summary-warning">
          <span [innerHTML]="((widgetTemplates() | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang()) | trustHtml"></span>
        </div>
      }
    </div>

    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-zip">
      <label class="input-label" for="invoice_address_zip" id="label_invoice_address_zip">
        {{ 'customer.zip.label' | translate }} *
      </label>
      <input
        id="invoice_address_zip"
        name="invoice_address_zip"
        type="text"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice postal-code"
        [value]="zip()"
        (input)="zip.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('zip')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('zip') }}"
        attr.aria-labelledby="label_invoice_address_zip"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('zip') ? 'error_invoice_address_zip' : null"
      />
      @if (isFieldRequiredAndEmpty('zip')) {
        <div id="error_invoice_address_zip" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.zip.error.required' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-city">
      <label class="input-label" for="invoice_address_city" id="label_invoice_address_city">
        {{ 'customer.city.label' | translate }} *
      </label>
      <input
        id="invoice_address_city"
        name="invoice_address_city"
        type="text"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice address-level2"
        [value]="city()"
        (input)="city.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('city')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('city') || isFieldPhishing('city') }}"
        attr.aria-labelledby="label_invoice_address_city"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('city') || isFieldPhishing('city') ? 'error_invoice_address_city' : null"
      />
      @if (isFieldRequiredAndEmpty('city')) {
        <div id="error_invoice_address_city" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.city.error.required' | translate }}
        </div>
      } @else if (isFieldPhishing('city')) {
        <div id="error_invoice_address_city" role="alert" class="alert alert-danger summary-warning">
          <span [innerHTML]="((widgetTemplates() | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang()) | trustHtml"></span>
        </div>
      }
    </div>

    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-country">
      <label class="input-label" for="invoice_address_country" id="label_invoice_address_country">
        {{ 'summary_page_translations.country' | translate }} *
      </label>
      <app-country-select
        id="invoice_address_country"
        name="invoice_address_country"
        [countries]="countries()"
        [lang]="lang()"
        bindLabel="name"
        bindValue="id"
        [searchable]="true"
        [clearable]="false"
        [required]="true"
        [ngModel]="countryId()"
        (ngModelChange)="onCountryChange($event)"
        attr.aria-required="true"
        attr.aria-labelledby="label_invoice_address_country"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-email">
      <label class="input-label" for="invoice_address_email" id="label_invoice_address_email">
        {{ 'customer.eMail.label' | translate }} *
      </label>
      <input
        id="invoice_address_email"
        name="invoice_address_email"
        type="email"
        class="form-control cbw-input-field"
        required
        maxlength="255"
        autocomplete="section-invoice email"
        [value]="email()"
        (input)="email.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('email')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('email') || isEmailInvalidAndFilled() }}"
        attr.aria-labelledby="label_invoice_address_email"
        [attr.aria-describedby]="isFieldRequiredAndEmpty('email') || isEmailInvalidAndFilled() ? 'error_invoice_address_email' : null"
      />
      @if (isFieldRequiredAndEmpty('email')) {
        <div id="error_invoice_address_email" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.eMail.error.required' | translate }}
        </div>
      } @else if (isEmailInvalidAndFilled()) {
        <div id="error_invoice_address_email" role="alert" class="alert alert-danger summary-warning">
          {{ 'customer.eMail.error.pattern' | translate }}
        </div>
      }
    </div>

    <div class="col-sm-6 custom-field form-group summary-padding cbw-invoice-address-phone">
      <label class="input-label" for="invoice_address_phone-cw-intel-tel" id="label_invoice_address_phone">
        {{ 'customer.phone.label' | translate }}
      </label>
      <!-- keyed on the country so picking another invoice country re-initialises the dial code -->
      @for (country of [phoneCountryCode()]; track country) {
        <app-cw-intl-tel-input
          name="invoice_address_phone"
          autocomplete="section-invoice tel"
          cssClass="customer-form-tel-input"
          [ngModel]="phone()"
          (ngModelChange)="onPhoneChange($event)"
          [ngModelOptions]="{ standalone: true }"
          [defaultCountry]="country"
          attr.aria-labelledby="label_invoice_address_phone"
        />
      }
    </div>
  </div>
}
